import React from 'react';
import { Shield, AlertCircle, RefreshCw } from 'lucide-react';

const PermissionFallback = ({ 
  onRetry, 
  error = null, 
  loading = false,
  className = '' 
}) => {
  if (loading) {
    return (
      <div className={`flex items-center justify-center p-8 ${className}`}>
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-2 text-gray-600">Carregando permissões...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`p-6 bg-red-50 border border-red-200 rounded-lg ${className}`}>
        <div className="flex items-start">
          <AlertCircle className="h-5 w-5 text-red-600 mt-0.5 mr-3" />
          <div className="flex-1">
            <h3 className="font-medium text-red-900">Erro ao carregar permissões</h3>
            <p className="text-sm text-red-800 mt-1">
              {error || 'Não foi possível carregar as permissões disponíveis.'}
            </p>
            {onRetry && (
              <button
                onClick={onRetry}
                className="mt-3 inline-flex items-center px-3 py-2 border border-red-300 text-sm font-medium rounded-md text-red-700 bg-white hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              >
                <RefreshCw className="h-4 w-4 mr-2" />
                Tentar novamente
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`p-6 bg-gray-50 border border-gray-200 rounded-lg ${className}`}>
      <div className="flex items-start">
        <Shield className="h-5 w-5 text-gray-400 mt-0.5 mr-3" />
        <div>
          <h3 className="font-medium text-gray-900">Nenhuma permissão disponível</h3>
          <p className="text-sm text-gray-600 mt-1">
            Não há permissões configuradas no sistema ou você não tem acesso para visualizá-las.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PermissionFallback;


